import React from "react";
import NotFound from "../components/NotFound/NotFound";
export default function NotFoundPage() {
  return (
    <div className="page-layout">
      <NotFound />
    </div>
  );
}
